export default {
    namespaced: true,
    state: {
        answers: [],
        currentQuestion: 0,
        isTestStarted: false,
        testResults: null,
    },
    mutations: {
        saveAnswer(state, { index, answer }) {
            state.answers[index] = answer;
            localStorage.setItem(
                "truecolors_answers",
                JSON.stringify(state.answers)
            );
        },
        updateCurrentQuestion(state, index) {
            state.currentQuestion = index;
            localStorage.setItem(
                "truecolors_current_question",
                index.toString()
            );
        },
        resetTest(state) {
            state.answers = [];
            state.currentQuestion = 0;
            state.isTestStarted = false;
            state.testResults = null;
            localStorage.removeItem("truecolors_answers");
            localStorage.removeItem("truecolors_current_question");
            localStorage.removeItem("truecolors_results");
        },
        setTestStarted(state, value) {
            state.isTestStarted = value;
        },
        setTestResults(state, results) {
            state.testResults = results;
            localStorage.setItem("truecolors_results", JSON.stringify(results));
        },
        restoreState(state) {
            const savedAnswers = localStorage.getItem("truecolors_answers");
            const savedQuestion = localStorage.getItem(
                "truecolors_current_question"
            );
            const savedResults = localStorage.getItem("truecolors_results");

            if (savedAnswers) {
                state.answers = JSON.parse(savedAnswers);
            }
            if (savedQuestion) {
                state.currentQuestion = parseInt(savedQuestion);
            }
            if (savedResults) {
                state.testResults = JSON.parse(savedResults);
            }
        },
    },
    actions: {
        saveAnswer({ commit }, { index, answer }) {
            commit("saveAnswer", { index, answer });
        },
        updateCurrentQuestion({ commit }, index) {
            commit("updateCurrentQuestion", index);
        },
        resetTest({ commit }) {
            commit("resetTest");
        },
        startTest({ commit }) {
            commit("resetTest");
            commit("setTestStarted", true);
            commit("updateCurrentQuestion", 0);
        },
        checkAnswersComplete({ state }, totalQuestions) {
            return (
                state.answers.length === totalQuestions &&
                state.answers.every((answer) => answer !== undefined)
            );
        },
        restoreState({ commit }) {
            commit("restoreState");
        },
        setTestResults({ commit }, results) {
            commit("setTestResults", results);
        },
    },
    getters: {
        getCurrentQuestion: (state) => state.currentQuestion,
        getAnswers: (state) => state.answers,
        hasTestStarted: (state) => state.isTestStarted,
        getTestResults: (state) => state.testResults,
        isAnswersComplete: (state) => (totalQuestions) => {
            return (
                state.answers.length === totalQuestions &&
                state.answers.every((answer) => answer !== undefined)
            );
        },
    },
};
